import './ScopeFilters.css'

type Scope = { companyName: string; clientName: string }
export const matchesScope = (item: Scope, company: string, client: string) =>
  (!company || item.companyName === company) && (!client || JSON.stringify([item.companyName, item.clientName]) === client)

export function ScopeFilters({ items, company, client, onChange }: {
  items: Scope[]; company: string; client: string; onChange: (company: string, client: string) => void
}) {
  const companies = [...new Set(items.map(x => x.companyName))].sort((a, b) => a.localeCompare(b, 'pt-BR'))
  const clients = [...new Map(items.filter(x => !company || x.companyName === company)
    .map(x => [JSON.stringify([x.companyName, x.clientName]), x])).entries()]
    .sort((a, b) => a[1].clientName.localeCompare(b[1].clientName, 'pt-BR'))
  return <div className="scope-filters">
    <label>Empresa<select aria-label="Filtrar empresa" value={company} onChange={e => onChange(e.target.value, '')}>
      <option value="">Todas as empresas</option>{companies.map(name => <option key={name}>{name}</option>)}
    </select></label>
    <label>Cliente/local<select aria-label="Filtrar cliente" value={client} onChange={e => onChange(company, e.target.value)}>
      <option value="">Todos os clientes</option>{clients.map(([key, x]) => <option key={key} value={key}>{x.clientName}{!company ? ` · ${x.companyName}` : ''}</option>)}
    </select></label>
    {(company || client) && <button type="button" onClick={() => onChange('', '')}>Limpar filtros</button>}
  </div>
}
